import React from 'react';
import { observer } from 'mobx-react-lite';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import TextDynamic from '@photosi/rn-components/text/text-dynamic/TextDynamic';
import { UserTextAreaModelInstance } from '../../../store/_models/userTextArea';
import { useResponsiveScale } from '../../../contexts/ResponsiveScaleContext';
import { TextAlignment } from 'src/constants/font.constants';
import { UserTextModelInstance } from 'src/store/_models/userText';
import { NoTranslate } from 'src/components/no-translate/NoTranslate';

export type UserTextProps = {
  userText: UserTextModelInstance;
  textArea: UserTextAreaModelInstance;
};

export const UserText = observer(({ userText, textArea }: UserTextProps) => {
  const { responsiveScaleSV, responsiveScale } = useResponsiveScale();

  // Create animated style for positioning
  const animatedStyle = useAnimatedStyle(
    () => ({
      position: 'absolute',
      left: textArea.x * responsiveScaleSV.value,
      top: textArea.y * responsiveScaleSV.value,
      width: textArea.width * responsiveScaleSV.value,
      height: textArea.height * responsiveScaleSV.value,
      justifyContent: 'center',
    }),
    [responsiveScaleSV, textArea.x, textArea.y, textArea.width, textArea.height],
  );

  return (
    <Animated.View style={animatedStyle}>
      <NoTranslate>
        <TextDynamic
          fontFamily={userText.font}
          fontStyle={userText.style}
          size={userText.size * responsiveScale}
          color={userText.color}
          alignment={userText.anchor as TextAlignment}
        >
          {userText.text}
        </TextDynamic>
      </NoTranslate>
    </Animated.View>
  );
});
